<template>
  <section class="pre-view">
    <article-header :type="1" @edit="goBackEdit" @submit="submit" />
    <div class="wrap">
      <div class="container">
        <h4>{{detail.title}}</h4>
        <div class="userInfo">
          <router-link
            :to="`/peopleCenter/${userInfo.userId}`"
            :class="{userType2:userInfo.userType===2 && userInfo.isCertification === 1}"
          >
            <img :src="userInfo.avatar| imageUrl('/static/profile_img_default.png',60,60)" alt />
            <span class="nickname">{{userInfo.nickname}}</span>
          </router-link>
        </div>
        <div class="content" v-html="detail.content"></div>
      </div>
    </div>
  </section>
</template>

<script>
import ArticleHeader from "@/components/v2/article/articleHeader";
export default {
  metaInfo() {
    return {
      title: this.$t("global.预览") + " | MANA"
    };
  },
  components: {
    ArticleHeader
  },
  data() {
    return {
      detail: {},
      userInfo: {}
    };
  },
  mounted() {
    this.topicQuestionId = this.$route.params.id;
    this.userInfo = this.$store.state.peopleMessage;
    this.getDetail();
  },
  methods: {
    getDetail() {
      const url = `/api/topic/answerInfo/preview`;
      const params = {
        topicQuestionId: this.topicQuestionId
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.detail = res.data.questionDomain;
        }
      });
    },
    goBackEdit() {
      this.$router.replace(`/article/edit?id=${this.topicQuestionId}`);
    },
    submit() {
      const url = `/api/u/topicquestion/updateArticleStatus`;
      const params = {
        oldStatus: this.detail.status,
        newStatus: 1,
        articleId: this.topicQuestionId
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message.success("发布成功");
          this.$router.push("/my/article");
        }
      });
    }
  }
};
</script>
<style>
.pre-view .content li {
  list-style: inherit!important;
}
</style>
<style lang="stylus" scoped>
.pre-view {
  background: #fff;

  .wrap {
    width: 730px;
    min-height: calc(100vh - 65px);
    margin: 0 auto;

    .container {
      width: 730px;
      padding-top: 156px;

      h4 {
        color: #0A0A0A;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }

      .userInfo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0 30px;

        a {
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;

          &.userType2::before {
            content: '';
            left: 20px;
            bottom: 0;
            position: absolute;
            width: 10px;
            height: 10px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 10px;
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 14px;
            border: 1px solid #f5f5f5;
          }

          span {
            font-size: 14px;
            color: #B8B8B8;

            &.nickname {
              color: #333333;
              padding-right: 15px;
              padding-left: 10px;
            }
          }
        }
      }

      .content {
        color: #333333;
        font-size: 16px;
        line-height: 30px;
        iframe{
          width 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/article/ArticlePreView.vue